var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card fit20-font-light activity-component-container"},[_c('img',{staticClass:"image",attrs:{"src":_vm.photo}}),_c('div',{staticClass:"text-sec"},[_c('p',{staticClass:"score"},[_vm._v(_vm._s(_vm.score > 0 ? '+' + _vm.score + '%' : _vm.score + '%'))]),_c('p',[_vm._v(_vm._s(_vm.item))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }